import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from 'src/environments/environment';
import { WordPaymentConfirmationDto } from '../_models/word-payment-confirmation.model';

@Injectable({
  providedIn: 'root'
})
export class WordConfirmationService {
  constructor(private httpClient: HttpClient) {}

  getPaymentSummary$(billId: string): Observable<WordPaymentConfirmationDto> {
    return this.httpClient.get<WordPaymentConfirmationDto>(
      `${env.WORD.BASE}${env.WORD.PAYMENTS.BILLS}/${billId}`
    );
  }
}
